import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import PackDetailPage from './PackDetailPage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'naddr': {
      const data = decoded.data;
      // Emoji pack (kind 30030)
      if (data.kind === 30030) {
        return <PackDetailPage />;
      }
      return <NotFound />;
    }

    default:
      return <NotFound />;
  }
}
